module.exports = __webpack_public_path__ + "static/media/bg-a3-portrait-proposed.6f420087.png";